import history from '../history';

type InputValidation = (value: number) => boolean;

export const inputValidation: InputValidation = value => {
    const divisibleByQuarter = value % 0.25 === 0;
    const lowerThanThree = value <= 3;
    const higherThanMinusOne = value >= -1;
    return divisibleByQuarter && lowerThanThree && higherThanMinusOne;
};

type GetRatingMethod = (defaultRating: string, rating: string) => string;

export const getRatingMethod: GetRatingMethod = (defaultRating, rating) => {
    let method = 'put';
    if (defaultRating !== '' && rating === '') {
        method = 'delete';
    }
    if (defaultRating === '' && rating !== '') {
        method = 'post';
    }
    return method;
};

export const redirectToFirstPage = () => history.push('/');

export const redirectToLoginPage = () => history.push('/login-google');
